<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">Homework</h1>

        <v-row>
            <v-col cols="8">
                <v-text-field
                        v-model="keyword"
                        label="Search"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>

            <v-col cols="2">
                <v-select :items="[{team_name: 'All', team_id: 0}, ...homework]"
                          label="Team"
                          item-text="team_name"
                          item-value="team_id"
                          v-model="team_id"
                          @change="getData()"
                >
                    <template v-slot:append>
                        <svg v-svg="'icon-select'" size="16"></svg>
                    </template>
                </v-select>
            </v-col>

            <v-col cols="2">
                <v-select :items="[{course_name: 'All', course_id: 0}, ...homework]"
                          label="Subject"
                          item-text="course_name"
                          item-value="course_id"
                          v-model="subject_id"
                          @change="getData()"
                >
                    <template v-slot:append>
                        <svg v-svg="'icon-select'" size="16"></svg>
                    </template>
                </v-select>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="homework"
                      :page.sync="pagination.current"
                      :items-per-page="pagination.rowsPerPage"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{(pagination.current - 1)*pagination.rowsPerPage+props.index+1}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 mr-1" @click="[$refs.show.dialog = true, selectedHomework = props.item.id]">
                    <svg v-svg="'icon-show'" size="12" class="mr-1"></svg>
                    <span class="show">Show</span>
                </v-btn>

                <v-btn text class="px-0 mx-2" @click="[$refs.delete.dialog = true, selectedHomework = props.item.id]">
                    <svg v-svg="'icon-delete'" size="12" class="mr-1"></svg>
                    <span class="red--text">Delete</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <div class="float-end mb-5">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>

        <show ref="show" :homework_id="selectedHomework"></show>
        <delete ref="delete" :homework_id="selectedHomework"></delete>
    </section>
</template>

<script>
    import Show from '@/components/Admin/Homework/Show';
    import Delete from '@/components/Admin/Homework/Delete';
    export default {
        components: {
            Show,
            Delete,
        },

        data(){
            return {
                timeout: null,
                loadingRequest : false,
                team_id: null,
                subject_id: null,
                keyword: null,
                selectedHomework: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: 'Title', sortable: false, value: 'title'},
                    {text: 'Team', sortable: false, value: 'team_name'},
                    {text: 'Subject', sortable: false, value: 'course_name'},
                    {text: 'Lesson', sortable: false, value: 'lesson_name'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
                homework: [],
                pagination: {},
            }
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData(1);
                }, 300);
            }
        },

        mounted() {
            this.getData();
            this.$on('getHomework', function () {
                this.getData();
            })
        },

        methods: {
            getData(page) {
                this.loadingRequest = true;
                this.$apiAdmin('homework').get({params: {page: page, subject_id: this.subject_id, team_id: this.team_id, keyword: this.keyword}}).then((res) => {
                    const response = res.data.homeworks;
                    this.pagination.rowsPerPage = response.per_page;
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.homework = response.data;
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/tablePages";
    @import "../../../scss/pages/Homework/index";
</style>